<template>
    <div class="container">
        <h3>{{ $t('other_last_polls') }}</h3>
        <div class="table-container">
            <table class="survey-table">
                <tr>
                    <th @click="change_order('institute')" :class="{active: sort_by == 'institute'}">{{ $t('other_institute') }}</th>
                    <th @click="change_order('date')" :class="{active: sort_by == 'date'}">{{ $t('other_date') }}</th>
                    <th @click="change_order('1')" :class="{active: sort_by == '1'}">{{ $t('other_party_chart_1') }}</th>
                    <th @click="change_order('4')" :class="{active: sort_by == '4'}">{{ $t('other_party_chart_4') }}</th>
                    <th @click="change_order('2')" :class="{active: sort_by == '2'}">{{ $t('other_party_chart_2') }}</th>
                    <th @click="change_order('3')" :class="{active: sort_by == '3'}">{{ $t('other_party_chart_3') }}</th>
                    <th @click="change_order('6')" :class="{active: sort_by == '6'}">{{ $t('other_party_chart_6') }}</th>
                    <th @click="change_order('5')" :class="{active: sort_by == '5'}">{{ $t('other_party_chart_5') }}</th>
                <tr v-for="(poll, i) in sorted" :key="i">
                    <td>{{ poll["1"].institute }}</td>
                    <td>{{ poll["1"].date | dateshort }}</td>
                    <td>{{ poll["1"].estimate | percentage(1) }}</td>
                    <td>{{ poll["4"].estimate | percentage(1)  }}</td>
                    <td>{{ poll["2"].estimate | percentage(1)  }}</td>
                    <td>{{ poll["3"].estimate | percentage(1)  }}</td>
                    <td>{{ poll["6"].estimate | percentage(1)  }}</td>
                    <td>{{ poll["5"].estimate | percentage(1)  }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { orderBy } from 'lodash';

export default {
    props: ["polls"],
    data () {
        return {
            sort_by: "date",
            sort_dir: "desc"
        }
    },
    computed: {
        sorted () {
            if (this.sort_by == "date") {
                return orderBy(this.polls, o => o["1"].date, [this.sort_dir]);
            } else if (this.sort_by == "institute") {
                return orderBy(this.polls, o => o["1"].institute, [this.sort_dir]);
            } else {
                return orderBy(this.polls, o => o[this.sort_by].estimate, [this.sort_dir]);
            }
        }
    },
    methods: {
        change_order(col) {
            if (this.sort_by == col) {
                this.sort_dir = this.sort_dir == 'asc' ? 'desc' : 'asc';
            } else {
                this.sort_by = col;
                this.sort_dir = 'asc';
            }
        }
    }
}
</script>

<style scoped>
.survey-table {
    width: 100%;
    border-spacing: 0;
}
.survey-table td,
.survey-table th{
    padding: 0.5em 0.2em;
    text-align: right;
}

.survey-table td:first-child,
.survey-table th:first-child,
.survey-table td:nth-child(2),
.survey-table th:nth-child(2)
 {
    text-align: left;
}

.survey-table tr:first-child th {
    border-bottom: 1px var(--black-primary) solid;
    white-space: nowrap;
    cursor: pointer;
    
}

.survey-table tr:first-child th.active {
    border-bottom: 3px var(--black-primary) solid;
    white-space: nowrap;
    cursor: pointer;
    padding-bottom: calc(0.5em - 2px);
    
}

.survey-table td {
    border-bottom: 1px var(--gray-light) solid;
}

.survey-table td:not(:first-child) {
    white-space: nowrap;
}

.survey-table tr:not(:first-child):hover td {
    background: var(--gray-extra-light);
}
</style>